import { KpiSheetColumn } from '../../../../_shared/components/kpi-sheet/kpi-sheet-models';
import {
    ISocialMediaOverviewConfig,
    ISocialMediaOverviewBillboardConfig,
    IDualAxisLineGraphConfig,
    ICardHeaderConfig,
    IDefaultTableColumnConfig } from '../../../../_shared/models/models-index';

export class SocialMediaOverviewConfig implements ISocialMediaOverviewConfig {
    public reportTitle: string;
    public useDefaultComparisonColumns: boolean = true;
    public billboards: ISocialMediaOverviewBillboardConfig[] = [];
    public kpiSheetOptions: any;
    public benchmarkCardHeader: ICardHeaderConfig = null;
    public trendGraphConfig: IDualAxisLineGraphConfig = null;
    public dealerTableColumns: IDefaultTableColumnConfig[] = [];
    public showTrendArrow: boolean = true;
}
